import { app } from '../config/app.js';

import {  getDataByKey } from './firestore.js';
import { useActionData } from 'react-router-dom';
export function getCapabilitiesByUser(user) {
    return {
        "can_admin":true
    }
}
export async function getUserData(user) {
    if (user=="loading" || user=="off") return null;
    const userFound=await getDataByKey("utenti",user.uid);
    if (typeof(userFound)==="undefined") throw new Error('Credenziali valide ma utente non configurato');
    //console.log(users);
    return userFound;


}

export function getPermission(type,target,operation,user) {
    const roleObj=app.ruoli[user.db.ruolo];
    let permissionObj=roleObj.capabilities["*"];
    switch (type) {
        case 'collection': 
            if (roleObj.capabilities && roleObj.capabilities[target])
                permissionObj=roleObj.capabilities[target];

            break;
        
        default: 
            break;
        
    }
    if (operation)
        return permissionObj[operation];
    return permissionObj;
}